import React from 'react';
import { Link } from 'react-router-dom';

const TwistedOasis = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black text-white p-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-7xl font-bold mb-4 bg-gradient-to-r from-red-500 to-orange-500 bg-clip-text text-transparent">
          🎮 Milkman's Twisted Oasis
        </h1>
        <p className="text-2xl text-gray-400 mb-12">Vehicular Combat Battle Arena</p>
        
        <div className="grid grid-cols-3 gap-6">
          <Link to="/skills" className="bg-gray-900/50 p-8 rounded-2xl border-2 border-red-500 hover:scale-105 transition-all">
            <div className="text-6xl mb-4">🌳</div>
            <h2 className="text-2xl font-bold">Skill Trees</h2>
            <p className="text-gray-400">18 unique skills</p>
          </Link>
          <Link to="/leaderboard" className="bg-gray-900/50 p-8 rounded-2xl border-2 border-yellow-500 hover:scale-105 transition-all">
            <div className="text-6xl mb-4">🏆</div>
            <h2 className="text-2xl font-bold">Leaderboard</h2>
            <p className="text-gray-400">Global rankings</p>
          </Link>
          <div className="bg-gray-900/50 p-8 rounded-2xl border-2 border-green-500 opacity-50">
            <div className="text-6xl mb-4">⚔️</div>
            <h2 className="text-2xl font-bold">Arena</h2>
            <p className="text-gray-400">Coming Soon</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwistedOasis;